<template>
  <div>
    <Head :title="`Editar: ${category.name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/spents">Gastos</Link>
      <span class="text-indigo-400 font-medium">/</span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/spent-categories">Categorías</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ category.name }}
    </h1>

    <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="w-full"
            label="Nombre de la Categoría"
            placeholder="Ej: Mantenimiento de Ascensores, Pozos de Agua, etc."
          />

          <div class="mt-4 p-4 rounded-md bg-blue-50 border border-blue-100 flex items-start">
            <svg class="h-5 w-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div class="text-sm text-blue-700">
              Esta categoría tiene <span class="font-bold">{{ category.spents_count }}</span> {{ category.spents_count === 1 ? 'gasto registrado' : 'gastos registrados' }}.
              <span v-if="category.spents_count > 0" class="block mt-1 text-xs text-blue-600">
                (No puede eliminarse mientras tenga gastos asociados para proteger la integridad histórica).
              </span>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="category.spents_count === 0"
            class="text-red-600 hover:text-red-800 text-sm font-medium hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy"
          >
            Eliminar Categoría
          </button>
          <div v-else></div>

          <div class="flex items-center space-x-3">
            <Link
              class="text-sm font-medium text-gray-600 hover:text-gray-900"
              href="/spent-categories"
            >
              Cancelar
            </Link>
            <loading-button :loading="form.processing" class="btn-blue" type="submit">
              Guardar Cambios
            </loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    category: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.category.name,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/spent-categories/${this.category.id}`)
    },
    destroy() {
      if (confirm(`¿Estás seguro de que deseas eliminar permanentemente la categoría "${this.category.name}"?`)) {
        this.$inertia.delete(`/spent-categories/${this.category.id}`)
      }
    },
  },
}
</script>
